module.exports = __webpack_public_path__ + "static/media/titan.05063828.png";